import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {globalDataSelector} from "../../../../redux/slices/globalDataSlice";
import Header from "../../../../components/Partials/Header/Header";
import SvgSelector from "../../../../components/SvgSelector/SvgSelector";
import ConfirmPopup from "../../../../components/UiKit/Popups/ConfirmPopup/ConfirmPopup";
import ActivateSubscriptionTopUpBalancePopup
    from "../../../../components/UiKit/Popups/ActivateSubscriptionTopUpBalancePopup/ActivateSubscriptionTopUpBalancePopup";
import subscriptionsPurpleBG from '../../../../assets/img/subscriptionsPurpleBG.png'
import subscriptionsSlateBG from '../../../../assets/img/subscriptionsSlateBG.png'
import subscriptionsDisabledSlateBG from '../../../../assets/img/subscriptionsDisabledSlateBG.png'
import subscriptionsRedBG from '../../../../assets/img/subscriptionsRedBG.png'
import subscriptionsDisabledRedBG from '../../../../assets/img/subscriptionsDisabledRedBG.png'
import subscriptionsBlueBG from '../../../../assets/img/subscriptionsBlueBG.png'
import subscriptionsDisabledBlueBG from '../../../../assets/img/subscriptionsDisabledBlueBG.png'
import s from './subscriptions.module.scss'
import {
    activateSubscription,
    disableAutoRenewSubscription,
    enableAutoRenewSubscription,
    renewSubscription,
    setFreeDomainsCount,
    setIsInitialInstallsLimits,
    setWasSubscriptionActivated,
    subscriptionSelector,
    updateSubscriptionsListAfterActivation,
    updateSubscriptionsListAfterDisablingAutoRenew,
    updateSubscriptionsListAfterEnablingAutoRenew
} from "../../../../redux/slices/subscriptionSlice";
import CustomSkeleton from "../../../../components/UiKit/CustomSkeleton/CustomSkeleton";
import {isDateAtLeastOneDayOlder} from "../../../../utils/helpers/dateHelpers";
import {
    activateSubscriptionUnsufficientFunds,
    unavailableTestSubscriptionActivation
} from "../../../../utils/vars/errorMessages";
import {getLanguage} from "../../../../storage/switchLanguage";
import {convertDate} from "../../../../utils/helpers/formatTime";
import {removeSubscriptionEndingLimits} from "../../../../storage/subscription";
import {snackbar_success, snackbar_warning} from "../../../../utils/vars/staticVariables";
import useCustomSnackbar from "../../../../hooks/useCustomSnackbar";

export const ANDROID = 'Android Star'
export const START = 'Start'
export const WILD = 'Wild Star'

export const subscriptionsInfoList = [
    {
        name: 'Test',
        description: 'Начните успешный запуск уже сейчас!',
        benefitsName: "Вы получаете доступ к приложениям, включающим:",
        bgImage: subscriptionsPurpleBG,
        extraBenefits: {
            name: '',
            benefitsList: []
        }
    },
    {
        name: START,
        description: 'subscriptions_info.start_tariff.desc',
        benefitsName: "subscriptions_info.start_tariff.benefits_name",
        bgImage: subscriptionsSlateBG,
        disabledBgImage: subscriptionsDisabledSlateBG,
        extraBenefits: {
            extraBenefitsName: '',
            extraBenefitsList: [
                'presence_10_team_members'
            ]
        },
    },
    {
        name: ANDROID,
        description: 'subscriptions_info.android_star_tariff.desc',
        benefitsName: "subscriptions_info.android_star_tariff.benefits_name",
        bgImage: subscriptionsBlueBG,
        disabledBgImage: subscriptionsDisabledBlueBG,
        extraBenefits: {
            extraBenefitsName: '',
            extraBenefitsList: [
                'access_to_other_android_sources',
                'presence_10_team_members'
            ]
        }
    },
    {
        name: WILD,
        description: 'subscriptions_info.wild_star_tariff.desc',
        benefitsName: "subscriptions_info.wild_star_tariff.benefits_name",
        bgImage: subscriptionsRedBG,
        disabledBgImage: subscriptionsDisabledRedBG,
        extraBenefits: {
            extraBenefitsName: 'А также:',
            extraBenefitsList: [
                'priority_issuance_of_android_sources',
                'retention_manager',
                'free_domains_ios_pwa',
                'private_fb_developers',
                'presence_20_team_members'
            ]
        }
    }
]

export const subscriptionLimits = [
    {
        iconId: 'google-play-limit-icon',
        defaultKey: 'android_install_count',
        subscriptionKey: 'subscription_android_install_count'
    },
    {
        iconId: 'app-store-limit-icon',
        defaultKey: 'ios_install_count',
        subscriptionKey: 'subscription_ios_install_count'
    },
    {
        iconId: 'pwa-limit-icon',
        defaultKey: 'pwa_install_count',
        subscriptionKey: 'subscription_pwa_install_count'
    }
];

const Subscriptions = () => {
    const [isSubscriptionsTopUpBalancePopupActive, setSubscriptionsTopUpBalancePopupActive] = useState(false);
    const [isConfirmSubscriptionActive, setConfirmSubscriptionActive] = useState(false);
    const [isDisableAutoRenewSubscriptionPopupActive, setDisableAutoRenewSubscriptionPopupActive] = useState(false);
    const [isEnableAutoRenewSubscriptionPopupActive, setEnableAutoRenewSubscriptionPopupActive] = useState(false);
    const [selectedTariff, setSelectedTariff] = useState({});
    const [notifyingModePopupData, setNotifyingModePopupData] = useState({});
    const [isNotifyingModePopupActive, setNotifyingModePopupActive] = useState(false);
    const [isRenewSubscription, setRenewSubscription] = useState(false);
    const [isTestTariffJustActivate, setTestTariffJustActivate] = useState(false);
    // const [isResetCounters, setIsResetCounters] = useState(false);
    const [activateSubscriptionPending, setActivateSubscriptionPending] = useState(false);
    const [disableAutoRenewSubscriptionPending, setDisableAutoRenewSubscriptionPending] = useState(false);
    const [enableAutoRenewSubscriptionPending, setEnableAutoRenewSubscriptionPending] = useState(false);
    const showSnackbar = useCustomSnackbar();
    const dispatch = useDispatch();
    const {isCollapsedSidebar} = useSelector(globalDataSelector);
    const {
        subscriptionsList,
        fetchSubscriptionsPending,
        isInitialInstallsLimits
    } = useSelector(subscriptionSelector);

    const {t} = useTranslation();

    const activeSubscription = subscriptionsList.find(item => item?.is_active === true)

    const testTariff = subscriptionsList.find(({name}) => name === 'Test')
    const majorSubscriptions = subscriptionsList.filter(({name}) => name !== 'Test')

    const displayInstalls = (count) =>
        Number.isFinite(count) ? `${count} ${t('subscription_installs_counter')}` : "All in";

    const onActivateSubscription = (tariffName) => {
        const selectedTariff = subscriptionsList.find(({name}) => name === tariffName)
        setSelectedTariff(selectedTariff)
        setConfirmSubscriptionActive(true)
    }

    const onDisableAutoRenewSubscription = (tariffName) => {
        const selectedTariff = subscriptionsList.find(({name}) => name === tariffName)
        setSelectedTariff(selectedTariff)
        setDisableAutoRenewSubscriptionPopupActive(true)
    }

    const onEnableAutoRenewSubscription = (tariffName) => {
        const selectedTariff = subscriptionsList.find(({name}) => name === tariffName)
        setSelectedTariff(selectedTariff)
        setEnableAutoRenewSubscriptionPopupActive(true)
    }

    const processSubscriptionAction = async () => {
        const resetActivationState = () => {
            setActivateSubscriptionPending(false);
            setConfirmSubscriptionActive(false);
        };

        const {name, id} = selectedTariff;
        const dataObj = {
            packet_name: name,
            subscribe_months: 1,
            renew_subscription: true,
        };

        setActivateSubscriptionPending(true);

        const action = isRenewSubscription ? renewSubscription : activateSubscription;

        const {data, status} = await dispatch(action(isRenewSubscription ? id : dataObj)).unwrap();

        const freeDomainsCount = data?.user_limits?.free_domains


        if (status === 200) {
            setTimeout(() => {
                if (!activeSubscription) {
                    dispatch(setIsInitialInstallsLimits(true))
                }
                dispatch(updateSubscriptionsListAfterActivation(data));
                dispatch(setWasSubscriptionActivated(true))
                removeSubscriptionEndingLimits()
                if (data?.subscription_name === 'Test') {
                    setTestTariffJustActivate(true)
                }
                if (isRenewSubscription) {
                    dispatch(setIsInitialInstallsLimits(true))
                }
                resetActivationState();
                setNotifyingModePopupData({
                    title: isRenewSubscription ? 'tariff_renewal' : 'tariff_activation',
                    description: isRenewSubscription ? 'tariff_renewed' : 'tariff_activated',
                });
                setNotifyingModePopupActive(true);
                if (freeDomainsCount) {
                    dispatch(setFreeDomainsCount(freeDomainsCount))
                } else {
                    dispatch(setFreeDomainsCount(0))
                }
            }, 2000);
        } else if (data?.detail === activateSubscriptionUnsufficientFunds) {
            setTimeout(() => {
                resetActivationState();
                setSubscriptionsTopUpBalancePopupActive(true);
            }, 1000);
        } else if (data?.detail === unavailableTestSubscriptionActivation) {
            setTimeout(() => {
                resetActivationState();
                setNotifyingModePopupData({
                    title: 'tariff_activation',
                    description: 'unable_to_activate_test_subscription',
                });
                setNotifyingModePopupActive(true);
            }, 1000);
        } else {
            setTimeout(() => {
                resetActivationState();
                setNotifyingModePopupData({
                    title: isRenewSubscription ? 'tariff_renewal' : 'tariff_activation',
                    description: isRenewSubscription ? 'tariff_renewal_error' : 'tariff_activation_error',
                    support: true,
                });
                setNotifyingModePopupActive(true);
            }, 1000);
        }
    };


    const disableAutoRenewSubscriptionHandler = async () => {
        const {id} = selectedTariff

        setDisableAutoRenewSubscriptionPending(true)

        const {status} = await dispatch(disableAutoRenewSubscription(id)).unwrap();

        if (status === 200) {
            setTimeout(() => {
                dispatch(updateSubscriptionsListAfterDisablingAutoRenew(selectedTariff?.name))
                setDisableAutoRenewSubscriptionPopupActive(false)
                setDisableAutoRenewSubscriptionPending(false)
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'you_disabled_subscription_auto_renewal',
                })
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'disable_auto_renewal_error',
                    support: true
                })
                setDisableAutoRenewSubscriptionPending(false)
                setDisableAutoRenewSubscriptionPopupActive(false)
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    const enableAutoRenewSubscriptionHandler = async () => {
        const {id} = selectedTariff

        setEnableAutoRenewSubscriptionPending(true)

        const {status} = await dispatch(enableAutoRenewSubscription(id)).unwrap();

        if (status === 200) {
            setTimeout(() => {
                dispatch(updateSubscriptionsListAfterEnablingAutoRenew(selectedTariff?.name))
                setEnableAutoRenewSubscriptionPopupActive(false)
                setEnableAutoRenewSubscriptionPending(false)
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'you_enabled_auto_renewal',
                })
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'enable_auto_renewal_error',
                    support: true
                })
                setEnableAutoRenewSubscriptionPending(false)
                setEnableAutoRenewSubscriptionPopupActive(false)
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    const isDisabledButtons = disableAutoRenewSubscriptionPending || enableAutoRenewSubscriptionPending || activateSubscriptionPending

    const isTestSubscriptionHidden = (testTariff?.start_date && !testTariff?.is_active)
        || majorSubscriptions?.some(obj => obj.is_active || obj.start_date);

    const installTypes = ['PWA', 'IOS', 'ANDROID'];

    const testSubscriptionInstallsList = installTypes.map(installName => {
        const countKey = `subscription_${installName.toLowerCase()}_install_count`

        return {
            installName,
            count: testTariff?.[countKey],
        };
    });

    const startDateOfSubscription = convertDate(activeSubscription?.start_date, 'DMY')
    const endDateOfSubscription = convertDate(activeSubscription?.end_date, 'DMY')

    const canBuySubscription = (selectedSubscriptionIndex) => {
        const subscriptionsWithEndDate = majorSubscriptions.filter(sub => sub.end_date);

        const highestEndDateSubscription = subscriptionsWithEndDate[subscriptionsWithEndDate.length - 1];

        return selectedSubscriptionIndex >= majorSubscriptions.indexOf(highestEndDateSubscription);
    };


    return (
        <div
            className={`${s.subscriptionsWrapper} ${isCollapsedSidebar === "true" ? s.collapsedSidebar : ""}`}
        >
            <Header/>
            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isConfirmSubscriptionActive}
                setActive={(value) => setConfirmSubscriptionActive(value)}
                action={processSubscriptionAction}
                confirmBtnText={isRenewSubscription ? t('renew_button') : t('activate_button')}
                title={t(isRenewSubscription ? 'tariff_renewal' : 'tariff_activation')}
                description={<>
                    {
                        `${t('you_are_about_to')}
                         ${isRenewSubscription ? t('renew') : t('activate')}`}
                    {" "}
                    <span className={s.highlight}>
                        {selectedTariff?.name}
                    </span>
                    {" " + t('subscription_word_in_popup_description')}
                </>}
                subDescription1={<>
                    {
                        getLanguage() === 'en'
                            ? <>
                            <span className={s.highlight}>
                                ${selectedTariff?.price}
                            </span>
                                {t('will_be_deducted_from_your_balance')}
                            </>
                            : <>
                                {t('will_be_deducted_from_your_balance')}
                                <span className={s.highlight}>
                                    {selectedTariff?.price}
                                </span>
                            </>
                    }
                    {
                        isRenewSubscription && t('renew_subscription_subdescription_info')
                    }
                </>}
                forcedClose={false}
                pending={activateSubscriptionPending}
            />
            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isDisableAutoRenewSubscriptionPopupActive}
                setActive={(value) => setDisableAutoRenewSubscriptionPopupActive(value)}
                action={disableAutoRenewSubscriptionHandler}
                confirmBtnText={t('disable_button')}
                title={t('subscription_auto_renewal_title')}
                description={<>
                    {t('disable_subscription_auto_renewal_popup_description')}{" "}
                    <span className={s.highlight}>
                        {selectedTariff?.name}
                    </span>?
                </>}
                subDescription1={<>
                    {t('subscription_auto_renewal_popup_subdescription')}
                </>}
                forcedClose={false}
                pending={disableAutoRenewSubscriptionPending}
            />
            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isEnableAutoRenewSubscriptionPopupActive}
                setActive={(value) => setEnableAutoRenewSubscriptionPopupActive(value)}
                action={enableAutoRenewSubscriptionHandler}
                confirmBtnText={t('enable_button')}
                title={t('subscription_auto_renewal_title')}
                description={<>
                    {t('enable_subscription_auto_renewal_popup_description')}{" "}
                    <span className={s.highlight}>
                        {selectedTariff?.name}
                    </span>
                    {" "}?
                </>}
                subDescription1={<>
                    {t('enable_subscription_auto_renewal_subdescription')}
                </>}
                forcedClose={false}
                pending={enableAutoRenewSubscriptionPending}
            />
            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isNotifyingModePopupActive}
                setActive={(value) => setNotifyingModePopupActive(value)}
                title={t(notifyingModePopupData?.title)}
                description={

                    notifyingModePopupData?.support ?
                        <>
                            {t(notifyingModePopupData?.description)}
                            . {t("contact")}{" "}
                            <a
                                href="https://t.me/TL_supp_wwa_vados"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t("supportPopupMessage")}
                            </a>
                        </> : t(notifyingModePopupData?.description)
                }
                forcedClose={true}
                cancelBtnText='close'
                notifyingMode
            />
            <ActivateSubscriptionTopUpBalancePopup
                isRenewSubscription={isRenewSubscription}
                subscriptionName={selectedTariff?.name}
                subscriptionPrice={selectedTariff?.price}
                active={isSubscriptionsTopUpBalancePopupActive}
                setActive={setSubscriptionsTopUpBalancePopupActive}
                action={value => setSubscriptionsTopUpBalancePopupActive(value)}
            />
            <div className={s.pageContent}>
                <div className={s.subscriptionsContainer}>

                    {
                        activeSubscription &&
                        <div className={s.currentSubscriptionInfo}>
                            <div className={s.leftPart}>
                                <div className={s.currentTariff}>
                                    <span>{t('your_current_tariff')}:</span>
                                    <span className={s.highlighted}>{activeSubscription?.name}</span>
                                </div>
                                <div className={s.buttonWrapper}>
                                    <button
                                        className={s.primaryBtn}
                                        disabled={isDisabledButtons || activeSubscription?.name === "Test"}
                                        onClick={() => {
                                            if (activeSubscription?.renew_subscription) {
                                                onDisableAutoRenewSubscription(activeSubscription?.name)
                                            } else {
                                                onEnableAutoRenewSubscription(activeSubscription?.name)
                                            }
                                        }}
                                    >
                                        {t('auto_renewal_title')}
                                    </button>
                                </div>
                            </div>
                            <div className={s.rightPart}>
                                <div className={s.topContainer}>
                                    <div className={s.tariffDate}>
                                        <span>{t('tariff_is_active')}:</span>
                                        <span
                                            className={s.highlighted}>{startDateOfSubscription} - {endDateOfSubscription}</span>
                                    </div>
                                    <div className={s.limits}>
                                        <span>{t('limits')}:</span>
                                        <ul>
                                            {subscriptionLimits.map(({iconId, defaultKey, subscriptionKey}) => (
                                                <li key={iconId}>
                                                    <SvgSelector id={iconId}/>
                                                    <span>
                                                      {!isInitialInstallsLimits
                                                          ? activeSubscription?.[defaultKey] ??
                                                          <SvgSelector id='all-in-icon'/>
                                                          : activeSubscription?.[subscriptionKey] ??
                                                          <SvgSelector id='all-in-icon'/>}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className={s.bottomContainer}>
                                    <div className={s.autoRenewMode}>
                                        <span>{t('auto_renewal_title')}:</span>
                                        <span
                                            className={`${s.highlighted} ${activeSubscription?.renew_subscription ? s.green : s.red}`}>
                                        {
                                            activeSubscription?.renew_subscription
                                                ? t('on')
                                                : t('off')
                                        }
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        fetchSubscriptionsPending
                            ? <CustomSkeleton styles={s.testTariffSkeletonStyle}/>
                            : !isTestSubscriptionHidden && <div
                            className={s.testTariffInfo}
                            style={{backgroundImage: `url(${subscriptionsPurpleBG})`}}
                        >
                            {testTariff?.is_active
                                ? <div className={s.activeTestTariffContent}>
                                    <p className={s.title}>
                                        {/*{t('current_tariff')}:{" "}*/}
                                        {testTariff?.name}
                                    </p>
                                    <ul className={s.detailsList}>
                                        {
                                            testSubscriptionInstallsList?.map(({installName, count}) => {

                                                return (
                                                    <li key={installName}>
                                                        {
                                                            (count === null || count > 0) &&
                                                            <SvgSelector id='circle-check'/>
                                                        }
                                                        {
                                                            count === 0 &&
                                                            <SvgSelector id='circle-cross'/>
                                                        }
                                                        <span>
                                                            {installName} - {displayInstalls(count)}
                                                        </span>
                                                    </li>
                                                )
                                            })
                                        }

                                    </ul>
                                </div>
                                : <div className={s.inactiveTestTariffContent}>
                                    <p className={s.title}>
                                        {t('activate_test_subscription_text')}
                                    </p>
                                    <p className={s.description}>
                                        {t('test_subscription_description')}
                                    </p>
                                    <div className={s.activateButtonWrapper}>
                                        <button
                                            className={s.whiteBorderBtn}
                                            disabled={isDisabledButtons}
                                            onClick={() => {
                                                setRenewSubscription(false)
                                                onActivateSubscription(testTariff?.name)
                                            }}
                                        >
                                            {t('activate_button')}
                                        </button>
                                    </div>
                                </div>}

                        </div>
                    }


                    <div className={s.cardsContainer}>

                        {
                            fetchSubscriptionsPending ? Array.from({length: 3}).map((_, index) => (
                                    <div key={index} className={s.skeletonCardWrapper}>
                                        <CustomSkeleton styles={s.skeletonStyle}/>
                                    </div>
                                )) :

                                majorSubscriptions.map(({
                                                            is_active,
                                                            end_date,
                                                            start_date,
                                                            renew_subscription,
                                                            name,
                                                            description,
                                                            benefitsName,
                                                            bgImage,
                                                            disabledBgImage,
                                                            extraBenefits,
                                                            price,
                                                            free_domains,
                                                            pwa_install_count,
                                                            ios_install_count,
                                                            android_install_count,
                                                            subscription_android_install_count,
                                                            subscription_pwa_install_count,
                                                            subscription_ios_install_count,
                                                            subscription_free_domains,
                                                        }, index) => {

                                    const {extraBenefitsName, extraBenefitsList} = extraBenefits


                                    // const installsList = [
                                    //     {
                                    //         installName: 'PWA',
                                    //         count: !isResetCounters && is_active ? pwa_install_count : subscription_pwa_install_count
                                    //     },
                                    //     {
                                    //         installName: 'IOS',
                                    //         count: !isResetCounters && is_active ? ios_install_count : subscription_ios_install_count
                                    //     },
                                    //     {
                                    //         installName: 'ANDROID',
                                    //         count: !isResetCounters && is_active ? android_install_count : subscription_android_install_count
                                    //     }
                                    // ]

                                    const installsList = [
                                        {
                                            installName: 'PWA',
                                            count: subscription_pwa_install_count
                                        },
                                        {
                                            installName: 'IOS',
                                            count: subscription_ios_install_count
                                        },
                                        {
                                            installName: 'ANDROID',
                                            count: subscription_android_install_count
                                        }
                                    ]

                                    const showedDomains = !isInitialInstallsLimits && is_active ? free_domains : subscription_free_domains

                                    return (
                                        <div className={`${s.card} ${is_active ? s.activated : ""}`}
                                             key={name}
                                             style={{backgroundImage: `url(${is_active ? disabledBgImage : bgImage})`}}
                                        >
                                            <div className={s.header}>
                                                {name}
                                                <div className={s.tariffNumber}>{index + 1}</div>
                                            </div>
                                            <div className={s.body}>
                                                <div className={s.priceContainer}>

                                                    <div className={s.price}>
                                                        $ {price}
                                                        <span className={s.month}>/{t('per_month')}</span>
                                                    </div>
                                                    <div className={s.fastDescription}>
                                                        {t(description)}
                                                    </div>
                                                </div>
                                                <div className={s.buttonsContainer}>
                                                    {
                                                        !is_active &&
                                                        <button
                                                            disabled={isDisabledButtons}
                                                            className={s.primaryBtn}
                                                            onClick={() => {
                                                                // if (canBuySubscription(index)) {
                                                                    setRenewSubscription(false)
                                                                    onActivateSubscription(name)
                                                                // } else {
                                                                //     showSnackbar(t("cannot_buy_this_subscription"), snackbar_warning);
                                                                // }
                                                            }}
                                                        >
                                                            {t('activate_button')}
                                                        </button>
                                                    }
                                                    {
                                                        is_active && <button
                                                            disabled={isDisabledButtons}
                                                            className={s.primaryBtn}
                                                            onClick={() => {
                                                                setRenewSubscription(true)
                                                                onActivateSubscription(name)
                                                            }}
                                                        >
                                                            {t('renew_button')}
                                                        </button>
                                                    }
                                                </div>
                                                <div className={s.benefitsContainer}>

                                                    <ul className={s.benefitsList}>
                                                        <p className={s.title}>
                                                            {t(benefitsName)}
                                                        </p>
                                                        {
                                                            installsList?.map(({installName, count}) => {
                                                                const installsValue = displayInstalls(count)
                                                                const isValueAllIn = displayInstalls(count) === "All in"


                                                                return (
                                                                    <li key={installName}>
                                                                        <SvgSelector id='transparent-circle-check'/>
                                                                        <span>
                                                                            {t(isValueAllIn ? 'access_to_all_apps' : 'access_to_apps')}
                                                                            {installName}
                                                                            {
                                                                                !isValueAllIn && ` - ${installsValue}`
                                                                            }
                                                                            {
                                                                                name === WILD && t('plus_private_apps_in_bot')
                                                                            }
                                                                        </span>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                        {
                                                            extraBenefitsList.map((item, index) => (
                                                                <li key={index}>
                                                                    <SvgSelector
                                                                        id={'transparent-circle-check'}/>
                                                                    <span>
                                                                        {t(item)}
                                                                    </span>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>

                                                    {/*{*/}
                                                    {/*    extraBenefitsList.length > 0 && <ul className={s.benefitsList}>*/}
                                                    {/*        <p className={s.title}>*/}
                                                    {/*            {extraBenefitsName}*/}
                                                    {/*        </p>*/}
                                                    {/*        {*/}
                                                    {/*            extraBenefitsList.map((item, index) => (*/}
                                                    {/*                <li key={index}>*/}
                                                    {/*                    <SvgSelector*/}
                                                    {/*                        id={is_active ? 'circle-check' : 'transparent-circle-check'}/>*/}
                                                    {/*                    <span>*/}
                                                    {/*                    {item}*/}
                                                    {/*                </span>*/}
                                                    {/*                </li>*/}
                                                    {/*            ))*/}
                                                    {/*        }*/}
                                                    {/*        {*/}
                                                    {/*            (showedDomains || showedDomains === 0) && (*/}
                                                    {/*                <li key={index}>*/}
                                                    {/*                    <SvgSelector*/}
                                                    {/*                        id={*/}
                                                    {/*                            !is_active*/}
                                                    {/*                                ? 'transparent-circle-check'*/}
                                                    {/*                                : (showedDomains > 0 ? 'circle-check' : 'circle-cross')*/}
                                                    {/*                        }*/}
                                                    {/*                    />*/}
                                                    {/*                    <span>*/}
                                                    {/*                        {t('free_domains')}: {showedDomains} (IOS/PWA)*/}
                                                    {/*                    </span>*/}
                                                    {/*                </li>*/}
                                                    {/*            )*/}
                                                    {/*        }*/}

                                                    {/*    </ul>*/}
                                                    {/*}*/}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Subscriptions;